// extracted by mini-css-extract-plugin
export default {"root":"style_root__EhawV","image":"style_image__SK1FM","data":"style_data__XvMeA","name":"style_name__eo5IZ"};